import { useMediaQuery } from 'react-responsive'

import { palette } from '../../../../styles/variables'
import { translate } from '../../../../utils/translation'
import { Text } from '../../../topography'
import starIcon from '../../../../styles/assets/checkoutModal/star.svg'
import ellipseIcon from '../../../../styles/assets/checkoutModal/ellipse.svg'

export default ({ style }) => {
  const isMobile = useMediaQuery({ maxWidth: 400 })

  return (
    <div
      style={{
        minHeight: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: palette.white,
        padding: isMobile ? '20px' : '0px 20px',
        flexDirection: isMobile ? 'column' : 'row',
        ...style,
      }}
    >
      <Text>
        <b>{translate('two_million')}</b>&nbsp;{translate('satisfied_users')}
      </Text>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: isMobile ? 'center' : 'flex-end',
          marginTop: isMobile ? '12px' : '0px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: 'bold',
          }}
        >
          <img
            src={starIcon}
            alt="Trustpilot Star"
            style={{ margin: '-2px 1px 0 0' }}
          />
          {translate('trustpilot')}
          <img
            src={ellipseIcon}
            alt="Ellipse"
            style={{ margin: '-1px 7px 0 7px' }}
          />
          {translate('reviews_excellent')}
        </div>
        <div
          style={{
            fontSize: '10px',
            lineHeight: '15px',
            color: palette.darkGray70,
            fontWeight: 'normal',
          }}
          dangerouslySetInnerHTML={{
            __html: translate('based_on_reviews', 256),
          }}
        />
      </div>
    </div>
  )
}
